import React, {useEffect} from 'react';
import {connect, useDispatch, useSelector} from 'react-redux';
import Button from "../../components/common/button/Button";
import styles from "./Confirm.module.scss";
import DefaultLayout from "../../layouts/DefaultLayout";
import moment from "moment";
import {resetSearch, sendNotification} from '../../redux/actions';

const Confirm = props => {
  const dispatch = useDispatch();
  const contactData = useSelector(state => state.contact);
  const personData = useSelector(state => state.person);
  const robotData = useSelector(state => state.robot);

  useEffect(() => {
    if(!robotData.notARobot) {
      props.history.push('/')
    }
  }, []);

  const {
    firstname, middlename, lastname,
    death, birth, nursingHome,
    certificateLongNum, certificateShortNum, currentAddress, deceasedState
  } = personData;

  let deceasedAddress = "";
  if (personData.currentAddress && personData.currentAddress.lookupValue) {
    deceasedAddress = personData.currentAddress.lookupValue.label;
  } else if (personData.currentAddress && personData.currentAddress.enterManually) {
    deceasedAddress = `${personData.currentAddress.addressLine}, ${personData.currentAddress.suburb} ${personData.currentAddress.state ? personData.currentAddress.state.label : ''} ${personData.currentAddress.postcode}`;
  }

  let contactAddress = "";
  if (contactData.postalAddress && contactData.postalAddress.lookupValue) {
    contactAddress = contactData.postalAddress.lookupValue.label;
  } else if (contactData.postalAddress && contactData.postalAddress.enterManually) {
    contactAddress = `${contactData.postalAddress.addressLine}, ${contactData.postalAddress.suburb} ${contactData.postalAddress.state ? contactData.postalAddress.state.label : ''} ${contactData.postalAddress.postcode}`;
  }


  const certificateNumber = !certificateLongNum || !certificateShortNum ? 'Not provided' : `${certificateLongNum}-${certificateShortNum}`;

  return <DefaultLayout>
    <div className={styles.mainCont}>
      <h2>Confirm</h2>
      <p>
        The following details will be passed on –
      </p>
      <div className={styles.editableSection}>
        <div className={'row'}>
          <div className={'col-6'}>
            <p>
              <em>
                Person who has died
              </em>
            </p>
          </div>
          <div className={'col-6'}>
            <Button
              secondary
              className={styles.editButton}
              onClick={() => {
                window.scrollTo(0, 0);
                props.history.push('/deceased-details')
              }}
            >Edit</Button>
          </div>
        </div>
        <p>
          {`${firstname || ''} ${middlename || ''} ${lastname || ''}`}
        </p>
        <p>
          Date of Birth: {birth ? moment(birth, "YYYY-MM-DD").format('D MMMM YYYY') : ''}<br/>
          Date of Death: {death ? moment(death, "YYYY-MM-DD").format('D MMMM YYYY') : ''}<br/>
          State/Territory where the person died: {deceasedState}
        </p>
        <p>
          {deceasedAddress  ? [<span>Address: {deceasedAddress}</span>, <br/>] : null}
          {nursingHome && nursingHome.value ? [<span>Nursing Home: {nursingHome.value}</span>, <br/>] : null}
          Death Certificate Registration Number: {certificateNumber}
        </p>
      </div>
      <div className={styles.editableSection}>
        <div className={'row'}>
          <div className={'col-6'}>
            <p>
              <em>
                Your details
              </em>
            </p>
          </div>
          <div className={'col-6'}>
            <Button
              secondary
              className={styles.editButton}
              onClick={() => {
                window.scrollTo(0, 0);
                props.history.push('/your-details')
              }}
            >Edit</Button>
          </div>
        </div>
        <p>
          {`${contactData.firstname || ''} ${contactData.middlename || ''} ${contactData.lastname || ''}`}
        </p>
        <p>
          Email: {contactData.emailAddress ? contactData.emailAddress : 'Not provided'}<br/>
          Contact Number: {contactData.contactNumber}<br/>
          {contactAddress  ? [<span>Address: {contactAddress }</span>, <br/>] : null}
        </p>
        <p>
          Role in the
          estate: {contactData.role} {contactData.role === 'Other' && contactData.other ? ` - ${contactData.other}` : ''}
        </p>
      </div>
      <div className={`row ${styles.buttonCont}`}>
        <div className={`col-6 ${styles.leftCont}`}>
          <Button secondary onClick={() => {
            window.scrollTo(0, 0);
            props.history.push('/your-details');
          }}>Back</Button>
        </div>
        <div className={`col-6 ${styles.rightCont}`}>
          <Button onClick={() => {
            dispatch(sendNotification(contactData, personData, () => {
              dispatch(resetSearch());
            }));
            window.scrollTo(0, 0);
            props.history.push('/finished')
          }}>Notify ANZ</Button>
        </div>
      </div>
    </div>
  </DefaultLayout>
};

export default connect(state => ({
  licenses: state.licenses,
}), {})(Confirm)
